// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wucu","col":"styles_col__2EWMQ"};